import { DashboardService } from '../../../../../core/services/dashboard.service';
import { DashboardProductForm } from '../../../../../forms/forms/dashboard-product.form';
import { ProductActionType } from '../../../../../shared/enums/product-action-type.enum';
import { DashboardForms } from '../../../../../shared/models/dashboard-forms.model';
import { ProductWithBarcode } from '../../../../../shared/models/product-with-barcode.model';

export abstract class DashboardActionDialogComponent {
  constructor(protected service: DashboardService) {}

  get forms(): DashboardForms {
    return this.service.forms;
  }

  get productActionType(): ProductActionType {
    return this.service.productActionType;
  }

  get productForm(): DashboardProductForm {
    return this.forms.product;
  }

  protected get product(): ProductWithBarcode | undefined {
    return this.service.product;
  }

  protected setProductActionType(productActionType: ProductActionType) {
    this.service.productActionType = productActionType;
  }
}
